import { render, staticRenderFns } from "./dettaglioSci.vue?vue&type=template&id=27142ea9"
import script from "./dettaglioSci.vue?vue&type=script&lang=js"
export * from "./dettaglioSci.vue?vue&type=script&lang=js"
import style0 from "./dettaglioSci.vue?vue&type=style&index=0&id=27142ea9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports